export default function Features() {
  const features = [
    {
      icon: 'ri-tools-fill',
      number: '+20',
      description: 'Años de experiencia en el rubro maderero'
    },
    {
      icon: 'ri-checkbox-circle-fill',
      number: '100%',
      description: 'Madera de calidad seleccionada y certificada'
    },
    {
      icon: 'ri-scissors-cut-fill',
      number: 'A Medida',
      description: 'Maquinaria propia para trabajos personalizados'
    },
    {
      icon: 'ri-truck-fill',
      number: 'Despacho',
      description: 'Región del Maule, O\'Higgins, RM y todo Chile'
    }
  ];

  return (
    <section className="py-20 bg-white/50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 text-center shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-20 h-20 mx-auto mb-6 bg-[#F5E6D3] rounded-full flex items-center justify-center">
                <i className={`${feature.icon} text-4xl text-[#5D4037]`}></i>
              </div>
              <div className="text-4xl font-bold text-[#5D4037] mb-3 font-serif">
                {feature.number}
              </div>
              <p className="text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
